import PizZip from "pizzip";
import docxtemplater from "docxtemplater";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";

// 导出echarts图片，格式转换
function base64DataURLToArrayBuffer(dataURL) {
  const base64Regex = /^data:image\/(png|jpg|svg|svg\+xml);base64,/;
  if (!base64Regex.test(dataURL)) {
    return false;
  }
  const stringBase64 = dataURL.replace(base64Regex, "");
  let binaryString;
  if (typeof window !== "undefined") {
    binaryString = window.atob(stringBase64);
  } else {
    binaryString = new Buffer(stringBase64, "base64").toString("binary");
  }
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes.buffer;
}

export function exportWord(data) {
  //这里要引入处理图片的插件，下载docxtemplater后，引入的就在其中了
  let ImageModule = require("docxtemplater-image-module-free");
  const expressions = require("angular-expressions");

  // 读取并获得模板文件的二进制内容 /demo.docx
  JSZipUtils.getBinaryContent("/demo.docx", (error, content) => {
    if (error) {
      throw error;
    }
    expressions.filters.size = function (input, width, height) {
      return {
        data: input,
        size: [width, height],
      };
    };

    function angularParser(tag) {
      const expr = expressions.compile(tag.replace(/’/g, "'"));
      return {
        get(scope) {
          return expr(scope);
        },
      };
    }

    // 图片处理
    let opts = {};

    opts = { centered: true, fileType: "docx" };

    opts.getImage = (chartId) => {
      return base64DataURLToArrayBuffer(chartId);
    };
    opts.getSize = function (img, tagValue, tagName) {
      //自定义指定图像大小
      if (tagName === "img") return [600, 200];
      return [300, 130];
    };

    // 创建一个PizZip实例，内容为模板的内容
    let zip = new PizZip(content);
    // 创建并加载docxtemplater实例对象
    let doc = new docxtemplater();
    doc.attachModule(new ImageModule(opts));
    doc.loadZip(zip);

    // 设置模板变量的值
    doc.setData({
      // ...form,
      title: data.title,
      time: data.time,
      regionImg: data.regionImg,
      departmentImg: data.departmentImg,
      systemImg: data.systemImg,
      img: data.img,
      departmentTab: data.departmentTab,
      systemTab: data.systemTab,
      regionTab: data.regionTab,
      tableHeader: data.tableData.tableHeader,
      table: data.tableData.table,
      overviewList: data.overviewList,
      electricList: data.electricList,
      value1: data.classificationList[0].num,
      name1: data.classificationList[0].name,
      value2: data.classificationList[1].num,
      name2: data.classificationList[1].name,
      value3: data.classificationList[2].num,
      name3: data.classificationList[2].name,
      value4: data.classificationList[3].num,
      name4: data.classificationList[3].name,
    });

    try {
      // 用模板变量的值替换所有模板变量
      doc.render();
    } catch (error) {
      // 抛出异常
      let e = {
        message: error.message,
        name: error.name,
        stack: error.stack,
        properties: error.properties,
      };
      // console.log(JSON.stringify({ error: e }));
      throw error;
    }

    // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
    let out = doc.getZip().generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    // 将目标文件对象保存为目标类型的文件，并命名
    saveAs(out, `能耗报表(${data.time}).docx`);
  });
}

/*** 运维报表*** */
export function exportDevOpsReportWord(data) {
  // 读取并获得模板文件的二进制内容 /devOpsReport.docx
  JSZipUtils.getBinaryContent("/devOpsReport.docx", (error, content) => {
    if (error) {
      throw error;
    }
    // 创建一个PizZip实例，内容为模板的内容
    let zip = new PizZip(content);
    // 创建并加载docxtemplater实例对象
    let doc = new docxtemplater();
    doc.loadZip(zip);

    // 设置模板变量的值
    doc.setData({
      // ...form,
      title: data.title,
      time: data.time,
      wordOrderData: data.wordOrderData,
      sourceData: data.sourceData,
      wordOrderTable: data.wordOrderTable,
      alarmData: data.alarmData,
      alarmTable: data.alarmTable,
      gradeData: data.gradeData,
      maintain: data.maintain,
    });

    try {
      // 用模板变量的值替换所有模板变量
      doc.render();
    } catch (error) {
      // 抛出异常
      let e = {
        message: error.message,
        name: error.name,
        stack: error.stack,
        properties: error.properties,
      };
      // console.log(JSON.stringify({ error: e }));
      throw error;
    }

    // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
    let out = doc.getZip().generate({
      type: "blob",
      mimeType:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    // 将目标文件对象保存为目标类型的文件，并命名
    saveAs(out, `运维报表(${data.time}).docx`);
  });
}

/**
 * 根据静态资源地址直接打出文件
 * @param data:Blob
 * @param fileName:string
 */
// 导出二进制流直接调这个方法
export const exportBlobFileFun = (data, fileName) => {
	saveAs(data, fileName)
}
/**
 * 根据静态资源地址直接打出文件
 * @param url:string
 * @param fileName:string
 */
export const exportFileByUrl = (url,fileName) => {
	saveAs(url,fileName)
}